<template>
   <div class="txet">

      <img src="../assets/img/logo.png" alt="" @click="logo">
  <el-menu
  :default-active="$route.path"
  class="el-menu-demo"
  mode="horizontal"
  @select="handleSelect"
  router
  text-color="#000"
  active-text-color=" #4990FF">
  <el-menu-item index="/home">首页</el-menu-item>

  <el-menu-item index="/mains" >关于我们</el-menu-item>
  <el-menu-item index="/mased">平台优势</el-menu-item>
  <el-menu-item index="/alge">合作案例</el-menu-item>

  <el-menu-item index="/handrs">合作伙伴</el-menu-item>
  <el-menu-item index="/industry">行业资讯</el-menu-item>
  <!-- <el-menu-item index="7" @mouseout.native="mashow" @mousemove.native="mdusf" >投放中心</el-menu-item> -->

</el-menu>
     <ul class="tlit" >
       <li v-for="(item,index) in list" :key="index"  @click="maquer(item)" @mouseleave="mashow(item)" @mousemove="mdusf(item)"   >{{item.name}}
       <ol class="bat" v-if="textbox" >
         <li v-for="(item1,index) in entrance" :key="index" @click="enrtbsty(item1)" @mouseenter="entrence(item1)" :class="{'ente' :cuytIds===item1.id}">{{item1.name}}</li>
       </ol>
       </li>

     </ul>

       <!-- <div class="text-box" v-if="textbox" ref="text"  @mouseleave="fdsg">
         <ol>
           <li  @click="enrtbsty(item)" @mouseenter="entrence(item)" :class="{'ente' :cuytIds===item.id}" v-for="(item,index) in entrance" :key="index">{{item.name}}</li>

         </ol>
      </div> -->
   </div>
</template>

<script>
export default {

  data () {
    return {
      textbox: false,
      list: [{ id: 8, name: '投放中心' }],
      entrance: [
        {
          id: 1,
          name: '入口一'
        },
        {
          id: 2,
          name: '入口二'
        },
        {
          id: 3,
          name: '入口三'
        }
      ],
      cuytId: '',
      cuytIds: ''

    }
  },
  watch: {
    $route (to, from) {

    }
  },
  methods: {
    handleSelect () {

    },
    maquer (item) {
      this.cuytId = item.id
      // if (item.id === 2) {
      //   this.$router.push('/mains')
      // } else if (item.id === 3) {
      //   this.$router.push('/mased')
      // } else if (item.id === 4) {
      //   this.$router.push('/alge')
      // } else if (item.id === 5) {
      //   this.$router.push('/handrs')
      // } else if (item.id === 6) {

      // } else if (item.id === 7) {
      //   this.$router.push('/industry')
      // } else if (item.id === 8) {

      // } else {
      //   this.$router.push('/')
      // }
    },
    mashow () {
      this.textbox = false
    },
    mdusf (item) {
      this.textbox = true
      //
    },
    fdsg () {
      this.textbox = false
    },
    enrtbsty (item) {
      const { id } = item
      if (id === 1) {
        window.location.href = 'http://adm.hundredzy.com/pages/signin'
      } else if (id === 2) {
        window.location.href = ' http://adm.hundredzy.com/pages/signin'
      } else {
        window.location.href = 'http://login.hundredzy.com/pages/signin'
      }
    },
    entrence (item) {
      console.log(item)
      this.cuytIds = item.id
    },
    logo () {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
    .txet {

      .el-menu.el-menu--horizontal {
          border-bottom: 0;
      }
      .el-menu--horizontal>.el-menu-item.is-active {

    border-bottom-color: #fff !important;
    border-bottom: 0;
      }
          img {
            float: left;
            width: 154px;
            height: 74px !important;
            vertical-align: middle;
            margin-top: 3px;
            margin-left: 155px;
            cursor: pointer;
          }
          position: relative;
          position: fixed;

          top: 0;
          left: 0;

        z-index: 444444444;
           background-color: #fff;
           width: 100%;
           height: 95px;
           .text-box {
             position: absolute;
             top: 73px;

             ol {
               li {

               }
             }

           }
           .tlit {
        position: absolute;
         top: 0px;
         left: 945px;
         .bat {
           width: 235px;
           margin-left: -60px;
           margin-top: 10px;
             .ente {
               background-color: #4990FF;
               color: #fff;
             }
           li {
          width: 135px;
             height: 71px;
             text-align: center;
             background-color: #fff;
             line-height: 71px;
             cursor: pointer;

           }
         }
           }
       ul {
         margin-top: 35px;
         margin-left: 50px;
         overflow: hidden;

          .ck {
             color: #000 !important;
             font-weight: 700 !important;
           }
         li {

       float: left;
       margin-left: 30px;
      //  width: 64px;
      //  height: 50px;
       font-size: 16px;
       font-family: Microsoft YaHei;
       font-weight: 400;
       color:#666;
       cursor: pointer;
       line-height: 19px;
      //  text-align: center;

      &:hover {
      .mdadges {
         width: 50px;
         height: 2.5px;
         margin: 0 auto;
         margin-top: 20px;
         background-color: #1482FF;
        // border-bottom: 1px solid #000;
        }
      }
       &:nth-child(2) {
          width: 84px;
          height: 20px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color:#666;
          line-height: 19px;
         }

           &:nth-child(3) {
          width: 85px;
          height: 20px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
           color:#666;
          line-height: 19px;
         }
           &:nth-child(4) {
           width: 84px;
           height: 20px;
           font-size: 16px;
           font-family: Microsoft YaHei;
           font-weight: 400;
            color:#666;
           line-height: 19px;
         }
         &:nth-child(5) {
         width: 85px;
        height: 20px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color:#666;
        line-height: 19px;
         }
           &:nth-child(6) {
           width: 85px;
          height: 20px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
           color:#666;
          line-height: 19px;
         }
              &:nth-child(7) {
               width: 85px;
               height: 20px;
               font-size: 16px;
               font-family: Microsoft YaHei;
               font-weight: 400;
               color:#666;
               line-height: 19px;
           }
           &:nth-child(8) {
               width: 85px;
               height: 20px;
               font-size: 16px;
               font-family: Microsoft YaHei;
               font-weight: 400;
               color:#666;
               line-height: 19px;

           }
         }

       }
     }
</style>
